import { Component, computed, Inject, inject, LOCALE_ID, Signal } from '@angular/core';
import { ButtonItemTemplateDirective, DropDownButtonComponent } from '@progress/kendo-angular-buttons';
import { LANGUAGES } from 'src/app/app.constants';
import { LanguageService } from 'src/app/shared/services/language.service';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [
    DropDownButtonComponent,
    ButtonItemTemplateDirective,
    UpperCasePipe
  ],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {
  private languageService = inject(LanguageService);

  readonly currentLanguage = this.languageService.currentLanguage;

  public data: Signal<{ text: string }[]>;

  constructor(@Inject(LOCALE_ID) public localeId: string) {
    this.data = computed(() =>
      LANGUAGES
        .filter(lang => lang !== this.currentLanguage())
        .map(lang => ({ text: lang }))
    );
  }

  changeLanguage(data: {text: string}) {
    this.languageService.changeLanguage(data.text);
  }
}
